// ko — checkin/quickCheck/stepTracker blocks translated.
export const ko = {
  "common": {
    "loading": "로딩 중...",
    "save": "저장",
    "cancel": "취소",
    "delete": "삭제",
    "edit": "편집",
    "close": "닫기",
    "confirm": "확인",
    "back": "뒤로",
    "next": "다음",
    "submit": "제출",
    "search": "검색",
    "select": "선택",
    "or": "또는",
    "and": "및",
    "note": "참고",
    "viewAll": "모두 보기",
    "learnMore": "더 알아보기",
    "getStarted": "시작하기",
    "continue": "계속하기",
    "saving": "저장 중…"
  },
  "nav": {
    "dashboard": "홈",
    "nutrition": "영양",
    "family": "가족",
    "care": "서비스",
    "careShort": "서비스",
    "checkIn": "체크인",
    "insights": "인사이트",
    "trends": "트렌드",
    "habits": "습관",
    "medications": "복약 관리",
    "expertSupport": "전문가 상담",
    "profile": "프로필",
    "healthHub": "헬스 허브",
    "support": "지원",
    "wellness": "웰니스",
    "education": "교육",
    "community": "커뮤니티",
    "preventiveHealth": "예방 건강",
    "womensHealth": "여성 건강",
    "reminders": "건강 알림",
    "meals": "식단",
    "orders": "주문",
    "subscription": "구독",
    "logout": "로그아웃"
  },

  "navShort": {
    "dashboard": "홈",
    "nutrition": "영양",
    "family": "가족",
    "care": "서비스",
    "support": "지원",
    "profile": "프로필"
  },
  "auth": {
    "login": "로그인",
    "register": "계정 만들기",
    "logout": "로그아웃",
    "email": "이메일",
    "password": "비밀번호",
    "name": "성함",
    "forgotPassword": "비밀번호를 잊으셨나요?",
    "noAccount": "계정이 없으신가요?",
    "haveAccount": "이미 계정이 있으신가요?",
    "signInHere": "여기에서 로그인하세요",
    "signUpHere": "여기에서 가입하세요",
    "welcomeBack": "다시 오신 것을 환영해요!",
    "getStarted": "시작해 볼까요?",
    "biometricLogin": "생체 인증 로그인",
    "biometricHelper": "지문, Face ID 또는 Windows Hello를 사용하세요",
    "vendorLogin": "파트너사 로그인",
    "createOne": "계정 생성",
    "tagline": "매일의 간단한 체크로 건강을 미리 관리하세요.",
    "takes30s": "30초도 걸리지 않아요",
    "emailPlaceholder": "you@example.com",
    "passwordPlaceholder": "비밀번호를 입력하세요",
    "checking": "확인 중…",
    "continue": "계속하기",
    "secureMessage": "안전하고 사적인 공간 — 귀하의 데이터는 보호됩니다",
    "biometricSoon": "생체 인증 로그인 — 곧 출시됩니다",
    "sessionExpired": "세션이 만료되었습니다. 중단된 곳부터 계속하려면 다시 로그인해 주세요.",
    "showPassword": "비밀번호 표시",
    "hidePassword": "비밀번호 숨기기",
    "vendor": {
      "title": "파트너사 로그인",
      "subtitle": "HealthLoop 파트너 대시보드에 접속하세요",
      "businessEmail": "비즈니스 이메일",
      "emailPlaceholder": "vendor@business.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "로그인 중...",
      "signIn": "로그인",
      "notVendorYet": "아직 파트너사가 아니신가요?",
      "registerBusiness": "비즈니스 등록하기",
      "areYouUser": "일반 사용자이신가요?",
      "userLogin": "사용자 로그인",
      "welcomeBackToast": "다시 오신 것을 환영합니다!",
      "genericError": "로그인에 실패했습니다. 다시 시도해 주세요."
    },
    "admin": {
      "backToUserLogin": "사용자 로그인으로 돌아가기",
      "title": "관리자 로그인",
      "restrictedBadge": "접근 제한",
      "tagline": "HealthLoop 운영 콘솔 — 관리자 권한이 필요합니다.",
      "emailLabel": "관리자 이메일",
      "emailPlaceholder": "admin@yourdomain.com",
      "passwordLabel": "비밀번호",
      "passwordPlaceholder": "관리자 비밀번호를 입력하세요",
      "signingIn": "로그인 중…",
      "submit": "관리자 콘솔 로그인",
      "secureNote": "보안 연결됨 · 세션 암호화됨",
      "restrictedTitle": "이 영역은 관리자 전용입니다.",
      "restrictedBody": "현재 계정으로 로그인되어 있으나 관리자 권한이 없습니다. 다른 계정으로 로그인하시려면 로그아웃하거나 메인 앱으로 돌아가세요.",
      "signOut": "로그아웃",
      "backToApp": "앱으로 돌아가기"
    }
  },
  "quickCheck": {
    "header": {
      "title": "오늘 컨디션은 어떠신가요?",
      "subtitle": "빠른 체크 — 60초도 걸리지 않아요"
    },
    "section1": {
      "title": "오늘 특별히 느껴지는 점이 있나요?",
      "hint": "(해당하는 것을 모두 선택)"
    },
    "environment": {
      "title": "오늘의 환경",
      "hint": "어떤 환경에 머무르셨는지 알려주세요"
    },
    "basicChecks": {
      "title": "간단 기본 체크",
      "hint": "선택 사항이지만 작성해 주시면 도움이 돼요"
    },
    "validation": {
      "pickOne": "최소 한 개 이상의 질문에 답변해 주세요"
    },
    "submit": {
      "cta": "건강 인사이트 보기",
      "saving": "저장 중...",
      "analyzing": "건강 패턴 분석 중...",
      "savedToast": "✅ 체크인 완료! 건강 패턴을 분석하고 있습니다..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "걸음 수 트래커",
      "subtitle": "나를 위한 정직한 활동 기록",
      "backToDashboard": "대시보드로 돌아가기"
    },
    "today": {
      "title": "오늘의 걸음",
      "goalProgress": "{{current}} / {{goal}} 걸음",
      "goalReached": "목표 달성 — 정말 멋져요!",
      "keepGoing": "지금처럼 계속해 봐요 — 잘하고 계세요."
    },
    "streak": {
      "label": "현재 연속 달성",
      "days": "{{count}}일",
      "daysPlural": "{{count}}일"
    },
    "badges": {
      "title": "배지",
      "empty": "습관을 기르다 보면 멋진 배지를 얻게 될 거예요."
    },
    "reminders": {
      "title": "움직임 알림",
      "hint": "오래 앉아 있을 때 가벼운 산책을 권하는 다정한 알림입니다.",
      "enabled": "사용 중",
      "disabled": "사용 안 함"
    },
    "insights": {
      "weeklyAverage": "주간 평균",
      "weeklyGoal": "주간 목표"
    },
    "actions": {
      "connect": "걸음 수 데이터 연결하기",
      "manualLog": "걸음 수 직접 기록하기",
      "changeGoal": "일일 목표 변경하기"
    }
  },
  "checkin": {
    "header": {
      "title": "오늘의 건강 체크인",
      "subtitle": "60초 이내에 완료할 수 있어요",
      "restDayLink": "오늘은 그냥 쉬고 싶어요"
    },
    "snapshot": {
      "title": "새로워진 대시보드",
      "healthScore": "건강 점수",
      "todayTasks": "오늘의 할 일",
      "dayStreak": "일 연속 달성"
    },
    "resume": {
      "banner": "중단했던 부분부터 다시 시작합니다",
      "startFresh": "처음부터 시작하기",
      "dismiss": "닫기"
    },
    "progress": {
      "allSet": "준비 완료",
      "step": "{{total}}단계 중 {{current}}단계",
      "ariaLabel": "일일 체크인 진행 상황: 전체 {{total}}개 섹션 중 {{done}}개 완료"
    },
    "insights": {
      "title": "나의 건강 인사이트",
      "subtitle": "오늘의 당신만을 위한 맞춤 정보",
      "insightForYou": "당신을 위한 건강 조언",
      "simpleActions": "지금 실천할 수 있는 간단한 행동",
      "whenToSeekHelp": "도움이 필요한 경우",
      "nhsAdvice": "걱정되는 증상이 있다면 전문가나 의료기관에 상담하세요",
      "backToDashboard": "대시보드로 돌아가기",
      "newCheckIn": "새 체크인",
      "disclaimer": "HealthLoop는 웰니스 가이드를 제공하며, 진단이나 치료를 대신하지 않습니다."
    },
    "restDay": {
      "title": "휴식도 건강한 흐름의 일부예요.",
      "body": "준비가 되면 내일 다시 만나요. 언제든 기다릴게요.",
      "streakNote": "기록이 멈춘 게 아니에요 — 당신과 함께 잠시 쉬어가는 중이랍니다.",
      "backToDashboard": "대시보드로 돌아가기",
      "changedMind": "생각해 보니 지금 체크인하고 싶어요."
    },
    "feelings": {
      "title": "오늘 컨디션은 어떠신가요?",
      "hint": "해당하는 것을 모두 선택해 주세요",
      "tired": "피곤함을 느껴요",
      "headache": "머리가 지끈거려요",
      "stressed": "스트레스나 부담감을 느껴요",
      "pain": "몸에 통증이나 뻐근함이 있어요",
      "okay": "오늘은 괜찮아요"
    },
    "basics": {
      "title": "기본 건강 체크",
      "sleepQ": "어제 잠은 푹 주무셨나요?",
      "waterQ": "오늘 물을 충분히 마셨나요?",
      "foodQ": "오늘 식사는 잘 챙겨 드셨나요?",
      "activityQ": "오늘 얼마나 활동적으로 지내셨나요?",
      "yes": "네",
      "notReally": "별로요",
      "notYet": "아직요",
      "notActive": "거의 움직이지 않았어요",
      "lightActivity": "가볍게 활동했어요",
      "active": "활기차게 움직였어요"
    },
    "mind": {
      "title": "마음과 에너지",
      "stressQ": "오늘의 스트레스 정도는 어떤가요?",
      "moodQ": "오늘의 기분은 어떠신가요?",
      "energyQ": "오늘 에너지는 어느 정도인가요?",
      "low": "낮음",
      "moderate": "보통",
      "high": "높음",
      "neutral": "그저 그래요",
      "good": "좋아요",
      "okay": "괜찮아요"
    },
    "day": {
      "title": "오늘의 하루",
      "routineQ": "오늘 평소 루틴을 잘 지키셨나요?",
      "yes": "네",
      "no": "아니요"
    },
    "environment": {
      "title": "오늘의 환경",
      "describeQ": "주변 환경이 어떠했는지 들려주세요.",
      "comfortable": "😊 쾌적했어요",
      "slightlyUncomfortable": "😐 조금 불편했어요",
      "challenging": "😓 힘들었어요",
      "affectedQ": "주변 환경이 컨디션에 영향을 주었나요?",
      "yes": "네",
      "no": "아니요",
      "exposureLabel": "노출 요인 (해당하는 것을 모두 선택)",
      "heat": "🌡️ 더위",
      "cold": "❄️ 추위",
      "noise": "🔊 소음",
      "dustSmoke": "💨 먼지나 연기",
      "crowded": "👥 붐비는 공간",
      "none": "✅ 없음"
    },
    "submit": {
      "analyzing": "건강 패턴을 분석하고 있어요...",
      "cta": "나의 건강 인사이트 확인하기"
    },
    "toast": {
      "savedFull": "체크인이 완료되었습니다! 대시보드가 업데이트되었어요.",
      "savedShort": "체크인이 저장되었습니다."
    }
  },
  "onboarding": {
    "welcome": "환영합니다",
    "completeSetup": "설정 완료",
    "stepProgress": "{{total}}단계 중 {{step}}단계",
    "percentComplete": "{{percent}}% 완료",
    "welcomeToast": "HealthLoop에 오신 것을 환영합니다! 프로필 설정이 완료되었습니다.",
    "errorAgeRange": "연령대를 선택해 주세요",
    "errorCountry": "국가를 선택해 주세요",
    "errorGoal": "주요 건강 목표를 선택해 주세요",
    "errorCuisine": "최소 하나 이상의 선호 요리를 선택해 주세요",
    "errorGeneric": "온보딩을 완료하지 못했습니다. 다시 시도해 주세요.",
    "step1Title": "HealthLoop에 오신 것을 환영합니다! 👋",
    "step1Subtitle": "귀하의 건강 여정을 맞춤화해 드릴게요",
    "ageRangeLabel": "연령대가 어떻게 되시나요?",
    "genderLabel": "성별 (선택 사항)",
    "gender_male": "남성",
    "gender_female": "여성",
    "gender_non-binary": "논바이너리",
    "gender_prefer_not_to_say": "응답 거부",
    "step2Title": "어디에 거주하시나요? 🌍",
    "step2Subtitle": "문화적으로 적합한 식단을 추천해 드리는 데 도움이 됩니다",
    "countryLabel": "국가 선택",
    "country_uk": "영국",
    "country_nigeria": "나이지리아",
    "country_ghana": "가나",
    "country_kenya": "케냐",
    "country_south_africa": "남아프리카 공화국",
    "country_usa": "미국",
    "country_canada": "캐나다",
    "country_india": "인도",
    "country_jamaica": "자메이카",
    "country_other": "기타",
    "step3Title": "주요 목표가 무엇인가요? 🎯",
    "step3Subtitle": "가장 우선적인 건강 목표를 선택해 주세요",
    "additionalGoals": "다른 목표가 더 있나요? (선택 사항)",
    "goal_weight_loss": "체중 감량",
    "goalDesc_weight_loss": "건강하게 체중 줄이기",
    "goal_weight_maintenance": "체중 유지",
    "goalDesc_weight_maintenance": "현재 체중 유지하기",
    "goal_muscle_gain": "근육 증량",
    "goalDesc_muscle_gain": "근력 및 근육 키우기",
    "goal_general_wellness": "일반 웰니스",
    "goalDesc_general_wellness": "전반적인 건강 증진",
    "goal_better_sleep": "숙면",
    "goalDesc_better_sleep": "수면의 질 개선",
    "goal_reduce_stress": "스트레스 완화",
    "goalDesc_reduce_stress": "스트레스 관리하기",
    "goal_increase_energy": "활력 증진",
    "goalDesc_increase_energy": "더 에너지 넘치는 생활",
    "step4Title": "음식 취향 🍽️",
    "step4Subtitle": "좋아하는 요리와 식단 제한 사항을 선택해 주세요",
    "cuisineLabel": "선호하는 요리",
    "cuisineHint": "최소 하나를 선택해 주세요 (중복 선택 가능)",
    "dietaryLabel": "식단 제한 사항 (선택 사항)",
    "diet_vegetarian": "채식주의",
    "diet_vegan": "비건",
    "diet_halal": "할랄",
    "diet_kosher": "코셔",
    "diet_gluten_free": "글루텐 프리",
    "diet_dairy_free": "유제품 프리",
    "diet_pescatarian": "페스카테리언",
    "step5Title": "건강 상태 🏥",
    "step5Subtitle": "선택 사항 — 더 나은 권장 사항을 제공해 드리는 데 도움이 됩니다",
    "conditionsLabel": "다음 중 해당되는 상태가 있으신가요?",
    "conditionsHint": "이 정보는 비공개로 유지되며 맞춤형 경험을 제공하는 데 사용됩니다",
    "condition_diabetes": "당뇨",
    "condition_hypertension": "고혈압",
    "condition_heart_disease": "심장 질환",
    "condition_thyroid": "갑상선 질환",
    "condition_celiac": "셀리악병",
    "condition_ibs": "과민성 대장 증후군(IBS)",
    "condition_none": "해당 없음",
    "privacyTitle": "귀하의 데이터는 보호됩니다",
    "privacyBody": "개인 정보는 암호화되어 안전하게 저장됩니다. 이 데이터는 맞춤형 식단 추천, 건강 팁 및 알림을 제공하는 데만 사용됩니다. 명시적인 동의 없이는 제3자와 데이터를 공유하지 않습니다.",
    "trackMedication": "복약 정보를 기록하고 싶어요",
    "specialistInterest": "전문가 상담에 관심이 있어요",
    "welcomeTitle": "HealthLoop에 오신 것을 환영해요! 👋",
    "welcomeSubtitle": "몇 가지 간단한 단계를 통해 AI 기반의 맞춤형 예방 건강 및 라이프스타일 가이드를 시작해 보세요",
    "stepLabel": "{{total}}단계 중 {{current}}단계",
    "skipForNow": "나중에 하기",
    "skipToast": "프로필에서 언제든지 온보딩을 완료하실 수 있어요",
    "back": "이전",
    "next": "다음",
    "completing": "완료 중...",
    "complete": "설정 완료",
    "successToast": "HealthLoop에 오신 것을 환영해요! 이제 맞춤형 프로필이 준비되었어요 🎉",
    "failureToast": "온보딩을 완료하지 못했어요",
    "validation": {
      "basicInfo": "모든 기본 정보를 입력해 주세요",
      "pickGoal": "건강 목표를 최소 하나 이상 선택해 주세요",
      "pickPrimary": "가장 중요한 핵심 목표를 선택해 주세요",
      "pickRegion": "맞춤형 식단 추천을 위해 문화권 지역을 선택해 주세요",
      "pickFocus": "가장 집중하고 싶은 웰니스 분야를 선택해 주세요"
    },
    "step1": {
      "title": "건강 프로필",
      "description": "사용자님을 위한 맞춤형 AI 건강 분석을 시작해 볼게요",
      "age": "나이 *",
      "agePlaceholder": "예: 30",
      "height": "키 (cm) *",
      "heightPlaceholder": "예: 170",
      "weight": "몸무게 (kg) *",
      "weightPlaceholder": "예: 70"
    },
    "step2": {
      "title": "건강 목표",
      "description": "해당되는 목표를 모두 선택하신 후, 핵심 목표를 골라주세요",
      "primaryLabel": "핵심 목표 선택 *",
      "primaryBadge": "핵심 목표"
    },
    "step3": {
      "title": "🌍 문화 및 음식 취향",
      "description": "더 정확한 식단 추천을 위해 정보를 알려주세요",
      "regionLabel": "문화권 지역 *",
      "regionHint": "맞춤형 식단 제안을 위해 본인의 문화적 배경을 선택해 주세요",
      "countryLabel": "국가 (선택 사항)",
      "countryPlaceholder": "예: 한국, 일본, 미국",
      "countryHint": "더욱 세밀한 맞춤 추천을 위해 입력해 주세요",
      "foodPrefLabel": "음식 다양성 선호도"
    },
    "step4": {
      "title": "주요 웰니스 포커스",
      "description": "가장 집중적으로 관리하고 싶은 분야를 선택해 주세요"
    },
    "step5": {
      "title": "사용자 설정",
      "description": "HealthLoop 경험을 나에게 맞게 설정해 보세요",
      "trackMeds": "복용 약물 관리",
      "trackMedsHint": "데일리 체크인에서 복용 중인 약물을 기록하고 알림을 받아보세요",
      "specialist": "전문가 지원에 관심 있음",
      "specialistHint": "웰니스 전문가, 영양사, 심리 상담 전문가의 도움을 받을 수 있어요",
      "confidentialTitle": "비밀 유지 안내:",
      "confidentialBody": "모든 정보는 안전하게 보호되며, 오직 맞춤형 예방 건강 정보를 제공하기 위한 목적으로만 사용됩니다."
    },
    "step6": {
      "title": "식단 맞춤 설정",
      "description": "입맛과 영양 상태에 딱 맞는 식단을 추천해 드릴게요",
      "cuisinesLabel": "선호하는 요리 (선택 사항)",
      "cuisinesHint": "가장 즐겨 드시는 요리 종류를 선택해 주세요",
      "dietaryLabel": "식이 요법 (선택 사항)",
      "dietaryHint": "해당되는 항목을 선택해 주세요",
      "allergiesLabel": "알레르기 정보 (선택 사항)",
      "allergiesHint": "음식 알레르기가 있다면 선택해 주세요",
      "personalisedTitle": "맞춤형 식단 추천:",
      "personalisedBody": "선택하신 취향을 바탕으로 입맛과 영양에 꼭 맞는 식단을 추천해 드려요. 설정에서 언제든지 변경할 수 있습니다."
    },
    "healthGoals": {
      "better_sleep": "숙면 취하기",
      "reduce_stress": "스트레스 해소",
      "increase_energy": "활력 증진",
      "weight_management": "체중 관리",
      "improve_fitness": "체력 향상",
      "better_nutrition": "영양 개선",
      "mental_wellness": "마음 건강",
      "chronic_condition": "만성 건강 관리"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "정신 건강",
        "description": "기분, 스트레스, 정서적 안정에 집중합니다"
      },
      "physical_fitness": {
        "label": "신체 건강",
        "description": "운동, 근력, 활동량 증진에 집중합니다"
      },
      "nutrition": {
        "label": "영양 관리",
        "description": "식단, 식사 습관, 건강한 음식 섭취에 집중합니다"
      },
      "sleep": {
        "label": "수면의 질",
        "description": "휴식, 수면 패턴, 회복에 집중합니다"
      },
      "stress_management": {
        "label": "스트레스 관리",
        "description": "이완과 스트레스 완화에 집중합니다"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "서아프리카",
        "description": "나이지리아, 가나, 세네갈 요리"
      },
      "east_african": {
        "label": "동아프리카",
        "description": "케냐, 에티오피아, 탄자니아 요리"
      },
      "north_african": {
        "label": "북아프리카",
        "description": "모로코, 이집트 요리"
      },
      "southern_african": {
        "label": "남아프리카",
        "description": "남아공 요리"
      },
      "caribbean": {
        "label": "카리브해",
        "description": "자메이카, 트리니다드, 바베이도스 요리"
      },
      "middle_eastern": {
        "label": "중동",
        "description": "레바논, 팔레스타인, 시리아 요리"
      },
      "south_asian": {
        "label": "남아시아",
        "description": "인도, 파키스탄, 방글라데시 요리"
      },
      "east_asian": {
        "label": "동아시아",
        "description": "한국, 중국, 일본 요리"
      },
      "southeast_asian": {
        "label": "동남아시아",
        "description": "태국, 베트남, 인도네시아 요리"
      },
      "western": {
        "label": "서구권",
        "description": "미국, 유럽 요리"
      },
      "latin_american": {
        "label": "라틴 아메리카",
        "description": "멕시코, 브라질, 아르헨티나 요리"
      },
      "mediterranean": {
        "label": "지중해",
        "description": "그리스, 이탈리아, 스페인 요리"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "전통식",
        "description": "주로 선택한 문화권의 요리"
      },
      "mixed": {
        "label": "혼합식",
        "description": "현지식과 세계 요리의 균형"
      },
      "international": {
        "label": "국제식",
        "description": "다양한 글로벌 요리"
      }
    },
    "cuisines": {
      "west_african": "서아프리카식",
      "caribbean": "카리브해식",
      "mediterranean": "지중해식",
      "asian": "아시아식",
      "western": "서구식",
      "indian": "인도식",
      "middle_eastern": "중동식",
      "general": "모든 요리"
    },
    "dietary": {
      "vegetarian": "채식주의",
      "vegan": "비건",
      "pescatarian": "페스카테리언",
      "gluten_free": "글루텐 프리",
      "dairy_free": "유제품 프리",
      "low_carb": "저탄수화물"
    },
    "allergies": {
      "nuts": "견과류",
      "shellfish": "갑각류",
      "dairy": "유제품",
      "eggs": "달걀",
      "soy": "콩",
      "gluten": "글루텐"
    },
    "cuisine_nigerian": "나이지리아식",
    "cuisine_ghanaian": "가나식",
    "cuisine_senegalese": "세네갈식",
    "cuisine_kenyan": "케냐식",
    "cuisine_ethiopian": "에티오피아식",
    "cuisine_moroccan": "모로코식",
    "cuisine_south_african": "남아프리카식",
    "cuisine_jamaican": "자메이카식",
    "cuisine_trinidadian": "트리니다드 토바고식",
    "cuisine_lebanese": "레바논식",
    "cuisine_turkish": "터키식",
    "cuisine_greek": "그리스식",
    "cuisine_italian": "이탈리아식",
    "cuisine_french": "프랑스식",
    "cuisine_british": "영국식",
    "cuisine_indian_south": "남인도식",
    "cuisine_indian_north": "북인도식",
    "cuisine_pakistani": "파키스탄식",
    "cuisine_japanese": "일식",
    "cuisine_chinese": "중식",
    "cuisine_korean": "한식",
    "cuisine_vietnamese": "베트남식",
    "cuisine_thai": "태국식",
    "cuisine_filipino": "필리핀식",
    "cuisine_american": "미국식",
    "cuisine_mexican": "멕시코식",
    "cuisine_brazilian": "브라질식",
    "cuisine_peruvian": "페루식"
  },
  "dashboard": {
    "welcome": "다시 오신 것을 환영해요",
    "greeting": "안녕하세요",
    "goodMorning": "좋은 아침이에요",
    "goodAfternoon": "즐거운 오후예요",
    "goodEvening": "편안한 밤이에요",
    "tagline": "작고 건강한 습관이 지속적인 변화를 만듭니다",
    "microcopy": "당신의 웰니스 여정은 소중합니다.",
    "welcomeSubtitleMorning1": "차분하게 하루를 시작해 보세요.",
    "welcomeSubtitleMorning2": "오늘 아침 들러주셔서 기뻐요.",
    "welcomeSubtitleMorning3": "작은 순간들이 모여 건강을 만듭니다.",
    "welcomeSubtitleAfternoon1": "안정적인 오후를 보내고 계시길 바라요.",
    "welcomeSubtitleAfternoon2": "HealthLoop에 다시 오신 것을 환영해요.",
    "welcomeSubtitleAfternoon3": "잠시 숨을 고르세요 — 잘하고 계세요.",
    "welcomeSubtitleEvening1": "하루를 함께 마무리해요.",
    "welcomeSubtitleEvening2": "오늘 하루를 부드럽게 정리해 보세요.",
    "welcomeSubtitleEvening3": "오늘 저녁 다시 만나서 반가워요.",
    "title": "예방 건강 인텔리전스 플랫폼",
    "subtitle": "문제가 커지기 전에 기록하고, 배우고, 조치를 취하세요",
    "summary": "건강 인텔리전스 요약",
    "summaryDesc": "예방, 교육, 참여 및 웰니스 전반에 걸친 실시간 인사이트",
    "comprehensiveSupport": "예방, 교육, 참여 및 웰니스를 아우르는 종합 지원",
    "todayCheckIn": "오늘의 체크인",
    "quickActions": "빠른 실행",
    "healthOverview": "건강 개요",
    "recentActivity": "최근 활동",
    "viewAll": "모두 보기",
    "preventiveHealth": "예방 건강",
    "preventiveHealthDesc": "일일 기록, 웰니스 모니터링 및 예방 알림",
    "education": "교육",
    "educationDesc": "근거 기반 인사이트, 건강 칼럼 및 전문가 가이드",
    "engagement": "참여",
    "engagementDesc": "커뮤니티 챌린지, 습관 추적 및 소셜 지원",
    "wellness": "웰니스",
    "wellnessDesc": "스마트 영양, 라이프스타일 균형 및 홀리스틱 건강",
    "todaysInsight": "오늘의 인사이트",
    "wellnessScore": "웰니스 점수",
    "healthStreak": "건강 스트릭",
    "days": "일",
    "logHealth": "건강 기록",
    "getEducated": "건강 공부하기",
    "communityChallenge": "커뮤니티 챌린지",
    "checkWellness": "웰니스 체크",
    "verified": "인증됨",
    "joinCommunity": "커뮤니티 참여",
    "personalizedPlan": "맞춤 플랜",
    "score": "점수",
    "checkIns": "체크인",
    "habits": "습관",
    "preventive": "예방",
    "healthMetrics": "건강 지표",
    "trackMetrics": "지표 추적",
    "startTracking": "추적 시작하기",
    "logMetrics": "지표 기록",
    "dailyInsight": "일일 인사이트",
    "learnAbout": "오늘의 예방 건강 정보",
    "articlesAvailable": "개의 읽을거리",
    "browseArticles": "칼럼 둘러보기",
    "currentStreak": "현재 스트릭",
    "keepGoing": "계속해 보세요!",
    "startStreak": "스트릭 시작하기",
    "checkIn": "체크인",
    "nutritionPlan": "영양 플랜",
    "mealsPlanned": "식단 계획됨",
    "viewPlan": "플랜 보기",
    "planYourWeek": "주간 계획 세우기",
    "moodStress": "기분 및 스트레스",
    "howFeeling": "현재 기분이 어떠신가요?",
    "logWellness": "웰니스 기록",
    "medications": "복약 관리",
    "noMeds": "기록된 약이 없습니다",
    "addMedications": "복약 정보 추가하기",
    "daysTracked": "추적된 일수",
    "noHabits": "아직 습관이 없습니다",
    "startTrackingHabits": "습관 추적 시작하기",
    "insights": "인사이트",
    "noInsights": "아직 인사이트가 없습니다",
    "completeFirstPlan": "첫 번째 플랜을 완료해 보세요",
    "noCheckIns": "아직 체크인이 없습니다",
    "startFirstCheckIn": "첫 체크인을 시작해 보세요"
  },
  "support": {
    "title": "지원",
    "subtitle": "답변을 찾거나 문의하고 문제를 신고하세요",
    "backToSettings": "설정으로 돌아가기",
    "privacyBanner": "지원 요청은 비공개로 안전하게 처리됩니다. 건강 정보는 비밀로 유지됩니다.",
    "section1": "섹션 1",
    "section2": "섹션 2",
    "section3": "섹션 3",
    "section4": "섹션 4",
    "navHelpCenter": "고객 센터",
    "navContact": "고객 지원 문의",
    "navHealth": "건강 서비스",
    "navTechnical": "기술 지원",
    "helpCenterTitle": "고객 센터",
    "helpCenterSubtitle": "자주 묻는 질문을 검색하고 빠른 답변을 찾아보세요.",
    "contactTitle": "고객 지원 문의",
    "contactSubtitle": "편하신 채널을 통해 저희 팀에 연락해 주세요.",
    "healthServicesTitle": "건강 서비스",
    "healthServicesSubtitle": "복약 추적 및 임상 전문가와 연결해 보세요.",
    "technicalTitle": "기술 지원",
    "technicalSubtitle": "버그나 기술적 문제를 상세히 설명하여 신고해 주세요.",
    "searchPlaceholder": "궁금한 내용을 검색하세요…",
    "liveChat": "실시간 채팅",
    "emailUs": "이메일 문의",
    "callBack": "전화 상담 예약",
    "sendMessage": "메시지 보내기",
    "medicationTracking": "복약 추적",
    "specialistAccess": "전문가 연결",
    "videoConsultation": "화상 상담",
    "reportBug": "버그 신고",
    "yourName": "이름",
    "yourEmail": "이메일",
    "subject": "제목",
    "message": "메시지",
    "phone": "전화번호",
    "description": "설명",
    "submit": "제출",
    "successTitle": "메시지 전송 완료",
    "successDescription": "24~48시간 이내에 답변해 드리겠습니다.",
    "healthDisclaimer": "응급 상황의 경우 현지 응급 서비스에 연락하세요. HealthLoop는 전문적인 의료 치료를 대체하지 않습니다."
  },
  "nutrition": {
    "smartNutrition": "스마트 영양",
    "basedOnGoal": "설정된 목표:",
    "personalizedData": "최근 건강 데이터를 바탕으로 맞춤화됨",
    "evidenceBased": "예방 건강 플랜의 일환인 근거 기반 영양 정보",
    "todaysMealSuggestions": "오늘의 추천 식단",
    "customize": "맞춤 설정",
    "breakfast": "아침",
    "lunch": "점심",
    "dinner": "저녁",
    "loadingBreakfast": "아침 식사 불러오는 중...",
    "loadingLunch": "점심 식사 불러오는 중...",
    "loadingDinner": "저녁 식사 불러오는 중...",
    "cal": "kcal",
    "protein": "단백질",
    "swapMeal": "식단 교체",
    "healthyOptionsNearYou": "주변의 건강한 선택지",
    "enableLocation": "위치 권한 허용",
    "view": "보기",
    "discoverOptions": "주변의 건강한 음식점, 식료품점, 식단 관리 업체를 찾아보세요",
    "cuisinesSelected": "개의 요리 선택됨",
    "cuisineSelected": "개의 요리 선택됨",
    "dietaryPrefs": "개의 식단 취향",
    "dietaryPref": "개의 식단 취향",
    "customizeMeals": "식단 맞춤 설정",
    "subtitleAdaptive": "건강 목표를 위해 문화적으로 조정된 맞춤형 식단 계획",
    "hideFavorites": "즐겨찾기 숨기기",
    "viewFavorites": "즐겨찾기 보기",
    "customizeMealsLegacy": "문화적 선호도와 식단 요구 사항에 맞춰 식단을 조정하세요",
    "viewFullPlan": "전체 플랜 보기",
    "exploreRecipes": "레시피 탐색"
  },
  "location": {
    "permissionTitle": "주변의 건강한 선택지 찾기",
    "permissionDesc": "건강 목표에 맞는 음식점, 식료품점, 식단 관리 업체를 추천하는 데 사용됩니다.",
    "howToEnable": "설정 방법:",
    "step1": "브라우저 주소창의 자물쇠 아이콘 🔒 클릭",
    "step2": "\"위치\" 권한 찾기",
    "step3": "\"허용\"으로 변경",
    "step4": "페이지 새로고침",
    "refreshPage": "페이지 새로고침",
    "allowLocation": "위치 허용",
    "notNow": "나중에 하기",
    "denied": "위치 접근이 차단되었습니다. 주변의 건강한 선택지를 보려면 위치 권한을 허용해야 합니다.",
    "unavailable": "위치 정보를 현재 사용할 수 없습니다. 기기 설정을 확인해 주세요.",
    "error": "위치 정보에 접근할 수 없습니다. 다시 시도하거나 브라우저 설정을 확인해 주세요.",
    "unsupported": "브라우저가 위치 서비스를 지원하지 않습니다. Chrome, Firefox, Safari와 같은 최신 브라우저를 사용해 보세요.",
    "accessRequired": "위치 권한 필요"
  },
  "womensHealth": {
    "title": "여성 건강",
    "description": "생리 주기를 추적하고, 증상을 기록하며, 주기 단계에 따른 맞춤 웰니스 팁을 받아보세요",
    "cycleTracking": "주기 추적",
    "symptomLogging": "증상 기록",
    "phaseInsights": "단계별 인사이트",
    "logPeriod": "생리 기록",
    "logSymptoms": "증상 기록",
    "insights": "인사이트",
    "tips": "건강 팁",
    "overview": "개요",
    "history": "기록",
    "startTracking": "주기 추적 시작하기"
  },
  "profile": {
    "title": "프로필",
    "personalInfo": "개인 정보",
    "healthProfile": "건강 프로필",
    "preferences": "환경 설정",
    "language": "언어",
    "selectLanguage": "언어 선택",
    "notifications": "알림",
    "privacy": "개인정보 보호",
    "security": "보안",
    "quickAccess": "빠른 접근",
    "editProfile": "프로필 편집",
    "viewStats": "통계 보기",
    "backToDashboard": "대시보드로 돌아가기",
    "womensHealthTitle": "여성 건강",
    "womensHealthDesc": "주기 추적, 증상 및 웰니스 팁",
    "healthRemindersTitle": "건강 알림",
    "healthRemindersDesc": "알림 관리",
    "manageRemindersDesc": "알림 설정 및 통지 관리",
    "healthPatternAlerts": "건강 패턴 알림",
    "supportHelp": "지원 및 도움말",
    "supportHelpDesc": "지원 받기, 문제 신고 또는 FAQ 보기",
    "admin": "관리자",
    "adminDesc": "사용 지표 및 사용자 행동 인사이트 보기",
    "giveFeedback": "의견 보내기",
    "giveFeedbackDesc": "HealthLoop 사용 경험을 공유해 주세요",
    "reportProblem": "문제 신고",
    "reportProblemDesc": "버그 수정 및 앱 개선을 도와주세요",
    "manageHealthInfo": "맞춤형 인사이트를 위해 예방 건강 정보를 관리하세요",
    "basicInformation": "기본 정보",
    "fullName": "성함",
    "email": "이메일",
    "dateOfBirth": "생년월일",
    "gender": "성별",
    "height": "키 (cm)",
    "weight": "몸무게 (kg)",
    "medicalConditions": "건강 상태",
    "allergies": "알레르기",
    "personalHealth": "개인 건강",
    "addCondition": "건강 상태 추가",
    "addAllergy": "알레르기 추가",
    "saveChanges": "변경사항 저장",
    "saving": "저장 중...",
    "privacyMessage": "귀하의 건강 데이터는 기밀 관리 표준에 따라 보호됩니다"
  },
  "settings": {
    "title": "설정",
    "general": "일반",
    "account": "계정",
    "appearance": "화면 설정",
    "languageSettings": "언어 설정",
    "changeLanguage": "언어 변경",
    "languageNote": "새로운 언어를 선택하는 즉시 인터페이스가 업데이트됩니다. 아프리카어 및 새로 추가된 일부 언어는 'Starter'로 표시되어 있으며, 이는 폭넓은 지원을 위한 기계 번역 단계로 원어민의 검토가 진행 중입니다.",
    "languageUpdated": "언어가 성공적으로 변경되었습니다",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "기계 번역본입니다 — 원어민 검토가 진행 중입니다.",
    "regions": {
      "global": "글로벌",
      "european": "유럽 언어",
      "middleEastern": "중동 언어",
      "asian": "아시아 언어",
      "african": "아프리카 언어"
    }
  },
  "search": {
    "triggerLabel": "HealthLoop 검색",
    "triggerHint": "\"걸음 수\", \"약국\" 또는 \"임신\"을 입력해 보세요",
    "triggerAriaLabel": "전체 검색 열기",
    "placeholder": "기능, 기록, 지원 서비스 검색…",
    "inputAriaLabel": "HealthLoop 기능 검색",
    "modalAriaLabel": "HealthLoop 검색",
    "close": "닫기",
    "clear": "지우기",
    "clearAriaLabel": "검색어 지우기",
    "recentSearches": "최근 검색어",
    "tryFor": "이런 검색어는 어떠세요?",
    "findFeatures": "원하는 기능을 바로 찾아보세요.",
    "searchAcross": "검색 범위:",
    "and": "및",
    "sections": {
      "home": "홈",
      "nutrition": "영양",
      "family": "가족",
      "services": "서비스",
      "support": "고객 지원",
      "profile": "프로필"
    },
    "noMatchesFor": "\"{{query}}\"에 대한 검색 결과가 없습니다",
    "trySimpler": "걸음 수, 영양 또는 전문의와 같은 간단한 단어로 검색해 보세요.",
    "comingSoonBadge": "출시 예정",
    "escToClose": "키로 닫기",
    "resultSingular": "{{count}}개의 결과",
    "resultPlural": "{{count}}개의 결과",
    "searchAcrossApp": "앱 전체 검색"
  },
  "familyMember": {
    "confirmRemove": "가족 건강 관리에서 {{name}} 님을 삭제하시겠습니까?",
    "removed": "가족 구성원에서 {{name}} 님이 삭제되었습니다",
    "removeFailed": "구성원 삭제에 실패했습니다",
    "viewDetails": "상세 보기",
    "edit": "수정",
    "remove": "삭제",
    "yearsSuffix": "세",
    "healthGoalsLabel": "건강 목표:",
    "moreSuffix": "개 더보기",
    "activeInsights": "활성 인사이트",
    "viewAllInsights": "전체 {{count}}개 인사이트 보기 →",
    "viewFullProfile": "전체 건강 프로필 보기",
    "lifeStage": {
      "infant": "영아 (0-2세)",
      "toddler": "유아 (2-5세)",
      "child": "어린이 (6-12세)",
      "adolescent": "청소년 (13-17세)",
      "adult": "성인 (18-59세)",
      "senior": "어르신 (60세 이상)",
      "unknown": "알 수 없음"
    }
  },
  "profileDeep": {
    "backToDashboard": "대시보드로 돌아가기",
    "profileCompletion": "프로필 완성도",
    "healthSummary": "건강 요약",
    "sectionA": "섹션 A",
    "sectionB": "섹션 B",
    "sectionC": "섹션 C",
    "sectionD": "섹션 D",
    "personalDetails": "개인 정보",
    "healthInformation": "건강 정보",
    "accountSettings": "계정 설정",
    "fullName": "성함",
    "email": "이메일",
    "dob": "생년월일",
    "gender": "성별",
    "genderPlaceholder": "예: 여성, 남성, 기타",
    "height": "키 (cm)",
    "heightPlaceholder": "예: 170",
    "weight": "몸무게 (kg)",
    "weightPlaceholder": "예: 70",
    "allergies": "알레르기",
    "allergiesPlaceholder": "예: 땅콩",
    "medicalConditions": "보유 질환",
    "conditionsPlaceholder": "예: 고혈압",
    "medications": "복용 중인 약",
    "medicationsPlaceholder": "예: 리시노프릴 10mg, 매일",
    "emergencyContact": "비상 연락처",
    "emergencyOptional": "(선택 사항)",
    "emergencyPlaceholder": "예: 어머니 +82-10-0000-0000",
    "emergencyNote": "사용자가 동의한 경우에만 전문가 공유 자료에 포함됩니다.",
    "saveChanges": "변경사항 저장",
    "saving": "저장 중…",
    "editProfile": "프로필 수정",
    "cancelEditing": "수정 취소",
    "healthScore": "건강 점수",
    "streak": "연속 달성",
    "streakDays": "{{n}}일",
    "memberSince": "가입일",
    "remindersActive": "알림 활성 상태",
    "conditionsTracked": "추적 중인 질환",
    "nextAgenda": "다음 일정",
    "notificationsReminders": "알림 및 리마인더",
    "notificationsRemindersDesc": "건강 알림 시간 및 채널 관리",
    "emailNudges": "이메일 알림",
    "emailNudgesDesc": "가벼운 리마인더 및 주간 요약",
    "on": "켜짐",
    "paused": "일시 정지",
    "privacySecurity": "개인정보 및 보안",
    "privacySecurityDesc": "계정 보안을 위해 비밀번호를 업데이트하세요",
    "preferencesTitle": "환경 설정",
    "preferencesDesc": "언어, 지역 및 맞춤 설정",
    "supportHelp": "지원 및 도움말",
    "supportHelpDesc": "궁금한 점을 해결하고 문의하기",
    "giveFeedback": "피드백 보내기",
    "giveFeedbackDesc": "개선이 필요한 점을 알려주세요",
    "reportProblem": "문제 신고",
    "reportProblemDesc": "버그를 발견하셨나요? 저희에게 알려주세요",
    "adminInsights": "관리자 인사이트",
    "adminInsightsDesc": "참여도 분석",
    "adminBadge": "관리자",
    "shareWithClinician": "전문가와 공유하기",
    "shareWithClinicianDesc": "조회 전용 요약 · 자동 만료 · 언제든지 취소 가능",
    "share": "공유",
    "profileMayBeOutOfDate": "프로필 정보가 최신이 아닐 수 있습니다",
    "profileMayBeOutOfDateDesc": "더 정확한 인사이트를 위해 웰니스 데이터를 최신으로 유지하세요. 몸무게나 복용 약물 같은 작은 변화도 맞춤형 알림을 제공하는 데 큰 도움이 됩니다.",
    "updateNow": "지금 업데이트",
    "profileUpdateError": "설정을 업데이트할 수 없습니다. 다시 시도해 주세요.",
    "healthLoopUser": "HealthLoop 사용자",
    "updatedLabel": "업데이트됨",
    "noEntries": "아직 기록이 없습니다.",
    "completionComplete": "프로필이 완성되었습니다. 최적의 웰니스 가이드를 제공해 드릴게요. 💚",
    "completionAlmostThere": "거의 다 왔습니다. 몇 가지 정보만 더 입력하시면 더 정확한 인사이트를 확인하실 수 있어요.",
    "completionInProgress": "프로필을 완성하고 더 나은 웰니스 인사이트를 받아보세요.",
    "justNow": "방금 전",
    "minAgo": "{{n}}분 전",
    "minsAgo": "{{n}}분 전",
    "hourAgo": "{{n}}시간 전",
    "hoursAgo": "{{n}}시간 전",
    "dayAgo": "{{n}}일 전",
    "daysAgo": "{{n}}일 전",
    "checkinDueToday": "오늘 체크인 예정",
    "checkinDueTonight": "오늘 밤 체크인 예정"
  },
  "supportDeep": {
    "backToSettings": "설정으로 돌아가기",
    "quickNavAria": "지원 섹션",
    "searchPlaceholder": "도움말 검색…",
    "searchAria": "자주 묻는 질문 검색",
    "resultsCount": "{{n}}개의 결과",
    "resultsCountPlural": "{{n}}개의 결과",
    "questionsCount": "{{n}}개의 질문",
    "liveChatTitle": "실시간 채팅",
    "liveChatDesc": "상담원과 실시간 대화 · 월~금 오전 9시~오후 6시",
    "startChat": "채팅 시작",
    "liveChatSoonToast": "실시간 채팅 서비스가 곧 출시됩니다. 그전까지는 이메일로 문의해 주세요.",
    "emailUsTitle": "이메일 문의",
    "emailUsDesc": "24~48시간 이내 답변",
    "copy": "복사",
    "emailCopied": "이메일 주소가 클립보드에 복사되었습니다.",
    "contactFormTitle": "문의 양식",
    "contactFormDesc": "메시지를 보내주시면 이메일로 답변해 드립니다.",
    "yourNameLabel": "이름 *",
    "namePlaceholder": "홍길동",
    "yourEmailLabel": "이메일 *",
    "emailPlaceholder": "jane@example.com",
    "subjectOptional": "제목 (선택 사항)",
    "subjectPlaceholder": "어떤 점을 도와드릴까요?",
    "messageLabel": "메시지 *",
    "messagePlaceholder": "도움이 필요한 내용을 입력해 주세요.",
    "sending": "전송 중…",
    "sendMessage": "메시지 보내기",
    "messageSent": "메시지 전송 완료",
    "messageSentDesc": "24~48시간 이내에 답변해 드리겠습니다.",
    "callbackTitle": "전화 상담 요청",
    "callbackDesc": "편하신 시간에 전화를 드립니다.",
    "phoneLabel": "전화번호 *",
    "phonePlaceholder": "010-1234-5678",
    "preferredTimeLabel": "희망 시간 (선택 사항)",
    "preferredTimePlaceholder": "예: 내일 오후",
    "reasonLabel": "상담 사유 (선택 사항)",
    "reasonPlaceholder": "어떤 내용에 대해 상담하고 싶으신가요?",
    "submitting": "제출 중…",
    "requestCallback": "상담 요청",
    "callbackRequested": "상담 요청 완료",
    "callbackRequestedDesc": "24시간 이내에 연락드리겠습니다.",
    "medicationSupport": "복약 지원",
    "medicationSupportDesc": "처방, 재처방 및 복약 알림 추적",
    "goToMedications": "복용 약물로 이동 →",
    "specialistConsultation": "전문가 상담",
    "specialistConsultationDesc": "개별 맞춤형 건강 가이드를 위해 전문가와 연결하세요.",
    "connectExpert": "전문가 연결하기 →",
    "videoConsult": "화상 상담",
    "videoConsultDesc": "전문가와 1:1 화상 상담을 예약하세요.",
    "bookConsultation": "상담 예약하기 →",
    "premium": "프리미엄",
    "healthDisclaimer": "HealthLoop는 일상적인 웰니스를 지원하며, 응급 의료 서비스를 대체하지 않습니다. 긴급한 상황인 경우 즉시 응급 서비스(119 등)에 연락하십시오.",
    "categoryLabel": "카테고리",
    "catBug": "버그 / 오류",
    "catPerformance": "속도 저하",
    "catFeature": "기능 작동 안 함",
    "catUi": "화면 표시 문제",
    "catOther": "기타",
    "issueTitle": "문제 제목 *",
    "issueTitlePlaceholder": "간략한 요약",
    "detailedDescription": "상세 설명 *",
    "detailedDescriptionPlaceholder": "어떤 문제가 발생했나요? 어떤 작업을 하던 중이었나요? 재현 순서를 알려주시면 큰 도움이 됩니다.",
    "autoAttachNote": "기기, 브라우저 및 화면 정보가 자동으로 첨부됩니다.",
    "submitReport": "신고서 제출",
    "reportSubmitted": "신고 완료",
    "reportSubmittedDesc": "저희 팀에서 확인 중입니다.",
    "fillAllFields": "필수 항목을 모두 입력해 주세요",
    "problemReportSubmittedToast": "문제 신고가 접수되었습니다. 확인 후 곧 연락드리겠습니다.",
    "messageSentToast": "메시지가 전송되었습니다. 24~48시간 이내에 답변해 드리겠습니다.",
    "callRequestedToast": "상담 요청이 접수되었습니다. 24시간 이내에 연락드리겠습니다.",
    "submitFailGeneric": "제출에 실패했습니다. 다시 시도하거나 {{email}}로 문의해 주세요.",
    "submitFailContact": "전송에 실패했습니다. {{email}}로 직접 이메일을 보내주세요.",
    "comingSoon": "출시 예정",
    "specialistRoadmapTitle": "전문가와 상담하기",
    "specialistRoadmapSubtitle": "전문가의 가이드 서비스가 곧 제공될 예정입니다. 도움이 필요할 때 언제든 이곳에서 연결할 수 있습니다.",
    "talkToSpecialistTitle": "전문가 상담",
    "talkToSpecialistDesc": "일상적인 건강 궁금증에 대해 공인 전문가와 실시간으로 채팅하세요.",
    "bookSpecialistTitle": "전문가 예약",
    "bookSpecialistDesc": "목표 달성을 위해 적합한 전문가와 1:1 세션을 예약하세요.",
    "liveHealthGuidanceTitle": "라이브 건강 가이드",
    "liveHealthGuidanceDesc": "증상, 검사 결과 또는 건강 관리 계획에 대한 화상 가이드를 받아보세요.",
    "mentalWellnessTitle": "마음 건강 지원",
    "mentalWellnessDesc": "삶이 버거울 때 심리 전문가로부터 비밀이 보장되는 지원을 받으세요.",
    "wellnessNavigationTitle": "웰니스 네비게이션",
    "wellnessNavigationDesc": "나에게 맞는 다음 단계를 선택할 수 있도록 도와주는 맞춤형 가이드입니다.",
    "pharmacyRoadmapTitle": "복약 및 약국 지원",
    "pharmacyRoadmapSubtitle": "약국 관련 도움말을 지원 및 도움말 섹션에서 한 번에 확인하세요.",
    "medicationGuidanceTitle": "복약 가이드",
    "medicationGuidanceDesc": "복용법, 시간 및 주의해야 할 약물 상호작용을 쉬운 용어로 설명해 드립니다.",
    "findNearbyPharmacyTitle": "주변 약국 찾기",
    "findNearbyPharmacyDesc": "약이 필요할 때 근처의 믿을 수 있는 약국을 빠르게 찾아보세요.",
    "refillReminderTitle": "재처방 알림 지원",
    "refillReminderDesc": "중요한 약이 떨어지지 않도록 미리 알려드립니다.",
    "otcWellnessTitle": "일반 의약품 상담",
    "otcWellnessDesc": "안전하고 과학적인 근거를 바탕으로 한 상비약 선택 가이드를 제공합니다."
  },
  "careServices": {
    "pageTitle": "케어 서비스",
    "pageSubtitle": "여러분의 일상 건강을 위해 설계된 전문적인 웰니스 지원 서비스입니다.",
    "specialistCareTitle": "전문가 케어",
    "specialistCareSubtitle": "전문가와 상담하고 필요할 때 적합한 전문가를 예약하세요.",
    "medicationPharmacyTitle": "복약 및 약국",
    "medicationPharmacySubtitle": "이해하기 쉬운 복약 안내와 약국 관련 도움을 드립니다.",
    "wellnessSupportTitle": "웰니스 지원",
    "wellnessSupportSubtitle": "마음 건강, 상비약 가이드 및 명확한 건강 관리 경로를 제공합니다.",
    "futureWellnessTitle": "향후 출시 예정 기능",
    "futureWellnessSubtitle": "HealthLoop가 준비 중인 예방 중심의 웰니스 기능을 미리 만나보세요.",
    "futureFeatureBadge": "출시 예정",
    "futurePersonalizedMealsTitle": "맞춤형 식단 계획",
    "futurePersonalizedMealsDesc": "목표, 알레르기, 문화적 취향을 반영한 웰니스 식단입니다.",
    "futureHealthyDeliveryTitle": "건강식 배달",
    "futureHealthyDeliveryDesc": "건강을 생각하는 주방 및 파트너사의 엄선된 음식을 배달해 드립니다.",
    "futureFarmFreshTitle": "산지 직송 웰니스 식품",
    "futureFarmFreshDesc": "지역 농장 및 제철 신선 식품 파트너와 직접 연결해 드립니다.",
    "futureFoodPartnershipsTitle": "웰니스 푸드 파트너십",
    "futureFoodPartnershipsDesc": "건강한 주방, 식료품점 및 웰니스 브랜드와 협력합니다.",
    "futureNutritionCoachingTitle": "영양 코칭",
    "futureNutritionCoachingDesc": "자격을 갖춘 영양 코치의 1:1 가이드를 받아보세요.",
    "futureFamilyWellnessTitle": "가족 웰니스 플랜",
    "futureFamilyWellnessDesc": "온 가족의 건강을 함께 지킬 수 있는 공유 플랜입니다.",
    "futureWellnessPlusTitle": "Wellness+ 멤버십",
    "futureWellnessPlusDesc": "개별 맞춤 가이드, 우선 지원 및 심층 인사이트를 제공하는 프리미엄 서비스입니다.",
    "futurePharmacyPartnersTitle": "약국 파트너십",
    "futurePharmacyPartnersDesc": "복약 가이드 및 재처방을 위한 신뢰할 수 있는 약국 네트워크입니다.",
    "futureAdvancedSpecialistTitle": "심화 전문가 케어",
    "futureAdvancedSpecialistDesc": "전문가 연결, 2차 소견 및 정밀 케어 안내를 지원합니다.",
    "futureWellnessMarketplaceTitle": "웰니스 마켓플레이스",
    "futureWellnessMarketplaceDesc": "엄선된 웰니스 제품과 서비스를 만나볼 수 있는 마켓입니다.",
    "futureVendorCollabTitle": "파트너 협력 시스템",
    "futureVendorCollabDesc": "건강 식품 및 웰니스 파트너를 위한 품질 관리 시스템입니다."
  },
  "dashboardDeep": {
    "healthProfile": "건강 프로필",
    "notifications": "알림",
    "familyAccounts": "가족 계정",
    "settings": "설정",
    "logout": "로그아웃",
    "allCaughtUp": "모든 확인을 마치셨습니다.",
    "weekInReview": "이번 주 요약",
    "dismissNotification": "알림 삭제",
    "dismissWeeklyDigest": "주간 요약 삭제",
    "notificationsAria": "알림",
    "profileMenuAria": "프로필 메뉴 열기",
    "loadingWellness": "웰니스 요약을 불러오는 중",
    "nextTip": "다음 팁",
    "todayAtGlance": "오늘의 현황",
    "healthScoreLabel": "건강 점수",
    "currentStreakLabel": "현재 연속 달성",
    "todaysProgress": "오늘의 진행 상황",
    "insightForYou": "나를 위한 인사이트",
    "checkMyHealthRisk": "나의 건강 리스크 체크",
    "quickAccess": "빠른 접근",
    "exploreCareServicesTitle": "케어 서비스 둘러보기",
    "exploreCareServicesSubtitle": "전문가 케어 · 약국 · 웰니스를 한곳에서 관리하세요.",
    "familyCare": "가족 케어",
    "healthLibrary": "건강 라이브러리",
    "myHealthData": "나의 건강 데이터",
    "askQuestion": "질문하기",
    "dashLoadError": "대시보드를 불러올 수 없습니다. 다시 시도해 주세요.",
    "taskUpdateError": "항목을 업데이트할 수 없습니다. 다시 시도해 주세요.",
    "perfectDay": "완벽한 하루네요! 🎉 연속 달성 기록이 연장되었습니다.",
    "letsStart": "시작하기",
    "yourNextStepToday": "오늘의 다음 단계",
    "completeDailyCheck": "오늘의 건강 체크 완료하기",
    "startDailyCheck": "체크인 시작하기",
    "viewAll": "전체 보기",
    "graceProtected": "유예 기간 적용됨",
    "todaysHealthRecommendations": "오늘의 건강 추천",
    "updateViaCheck": "데일리 체크로 업데이트",
    "healthInsight": "건강 인사이트",
    "riskCheckSubtext": "몇 초 만에 개인별 건강 인사이트를 확인하세요",
    "foodDiet": "음식 및 식단",
    "healthScoreNew": "건강 점수 · 신규",
    "letsBuildScore": "함께 건강 점수를 높여봐요",
    "oneHealthyHabitAtATime": "한 번에 하나씩 건강한 습관을 만들어가요.",
    "nextCheck": "다음 체크:",
    "todayAt8pm": "오늘 오후 8:00",
    "wellnessTipForYou": "오늘의 웰니스 팁 · 맞춤형",
    "wellnessTipForFactor": "오늘의 웰니스 팁 · {{factor}} 관련",
    "logged": "기록됨",
    "gotIt": "확인했어요 👍",
    "gladToSeeYou": "오늘도 만나서 반가워요 💚",
    "takesLessThan60Sec": "60초도 걸리지 않아요",
    "scoreReadyWhenYou": "준비되시면 시작하세요",
    "scoreCompleteFirstCheck": "첫 번째 웰니스 체크를 완료하고 맞춤형 인사이트를 받아보세요.",
    "scoreExcellent": "매우 좋음",
    "scoreSupportExcellent": "오늘 건강 상태가 아주 좋습니다. 이대로 유지해 보세요.",
    "scoreGood": "좋음",
    "scoreSupportGood": "잘하고 계시네요. 건강한 습관을 계속 이어가세요.",
    "scoreModerate": "보통",
    "scoreSupportModerate": "괜찮은 편이지만, 몇 가지 주의가 필요한 부분이 있습니다.",
    "scoreNeedsAttention": "주의 필요",
    "scoreSupportNeedsAttention": "오늘 건강 관리에 주의가 필요합니다. 작은 변화가 건강을 개선할 수 있습니다."
  },
  "emailVerify": {
    "bannerWithEmail": "계정 보안과 데일리 알림을 위해 이메일({{email}})을 인증해 주세요.",
    "bannerNoEmail": "계정 보안과 데일리 알림을 위해 이메일을 인증해 주세요.",
    "sending": "전송 중…",
    "resend": "이메일 재전송",
    "sentToast": "인증 이메일이 전송되었습니다. 받은 편지함을 확인해 주세요.",
    "sendFailToast": "인증 이메일을 보낼 수 없습니다. 나중에 다시 시도해 주세요."
  },
  "forgotPassword": {
    "title": "비밀번호를 잊으셨나요?",
    "subtitle": "걱정 마세요! 이메일을 입력하시면 재설정 방법을 보내드립니다.",
    "emailLabel": "이메일 주소",
    "emailPlaceholder": "your.email@example.com",
    "sendResetLink": "재설정 링크 보내기",
    "sending": "전송 중…",
    "backToLogin": "로그인으로 돌아가기",
    "resendLink": "이메일 재전송",
    "successTitle": "이메일을 확인해 주세요",
    "successBody": "{{email}} 계정이 존재하면 비밀번호 재설정 링크를 보내드립니다.",
    "linkExpires": "링크는 30분 후에 만료됩니다.",
    "successToast": "이메일에서 재설정 방법을 확인해 주세요",
    "errEmptyEmail": "이메일 주소를 입력해 주세요",
    "errInvalidEmail": "올바른 이메일 형식을 입력해 주세요",
    "errNetwork": "서버에 연결할 수 없습니다. 네트워크 상태를 확인하고 다시 시도해 주세요.",
    "errGeneric": "재설정 이메일을 보낼 수 없습니다. 다시 시도하거나 지원팀에 문의해 주세요."
  },
  "resetPassword": {
    "title": "새 비밀번호 설정",
    "subtitle": "계정에 사용할 강력한 비밀번호를 만드세요",
    "newPasswordLabel": "새 비밀번호",
    "newPasswordPlaceholder": "새 비밀번호 입력",
    "confirmPasswordLabel": "비밀번호 확인",
    "confirmPasswordPlaceholder": "새 비밀번호 다시 입력",
    "requirementsHint": "대문자, 소문자, 숫자를 포함하여 8자 이상이어야 합니다",
    "resetPassword": "비밀번호 재설정",
    "resetting": "재설정 중…",
    "successTitle": "비밀번호 재설정 완료!",
    "successBody": "이제 새 비밀번호로 로그인하실 수 있습니다.",
    "successToast": "비밀번호가 성공적으로 재설정되었습니다!",
    "goToLogin": "로그인하러 가기",
    "invalidLinkTitle": "유효하지 않은 링크",
    "invalidLinkBody": "이 비밀번호 재설정 링크는 유효하지 않거나 만료되었습니다.",
    "requestNewLink": "새 링크 요청하기",
    "showPassword": "비밀번호 표시",
    "hidePassword": "비밀번호 숨기기",
    "errInvalidLink": "유효하지 않은 재설정 링크입니다",
    "errMismatch": "비밀번호가 일치하지 않습니다",
    "errTooShort": "비밀번호는 8자 이상이어야 합니다",
    "errExpiredToken": "재설정 링크가 만료되었거나 유효하지 않습니다. 새 링크를 요청해 주세요.",
    "errNetwork": "서버에 연결할 수 없습니다. 네트워크 상태를 확인하고 다시 시도해 주세요.",
    "errGeneric": "비밀번호 재설정에 실패했습니다. 다시 시도해 주세요."
  },
  "tips": {
    "water1": "잠에서 깨어난 후 30분 이내에 물을 마시면 수분 보충과 에너지 수준 향상에 도움이 될 수 있습니다.",
    "water2": "식사 전 물 한 잔은 갈증을 미리 해소할 수 있는 좋은 방법입니다.",
    "water3": "물에 레몬 조각이나 민트 잎을 넣으면 수분 보충을 더욱 즐겁게 할 수 있습니다.",
    "meals1": "하루 한 접시의 채소를 추가하는 것은 장과 심장 건강에 도움이 됩니다.",
    "meals2": "아침 식사에 한 줌의 견과류나 씨앗을 곁들이면 오전 내내 에너지를 유지하는 데 도움이 됩니다.",
    "meals3": "과일 주스보다는 생과일을 드세요. 섬유질이 혈당을 더 완만하게 유지해 줍니다.",
    "steps1": "식후 10분 정도 걸으면 몸이 당분을 더 부드럽게 처리하는 데 도움이 됩니다.",
    "steps2": "아침 5분의 스트레칭은 긴장을 완화하고 차분하게 하루를 시작하도록 도와줍니다.",
    "steps3": "하루에 한 번이라도 계단을 이용하면 시간이 지나면서 심폐 기능이 튼튼해집니다.",
    "sleep1": "잠들기 한 시간 전 조명을 낮추면 몸이 깊은 잠을 잘 준비를 하는 데 도움이 됩니다.",
    "sleep2": "주말에도 규칙적인 시간에 일어나는 습관은 안정적인 수면 주기를 만들어 줍니다.",
    "sleep3": "아침에 10분 동안 햇볕을 쬐면 자연스럽게 수면 리듬을 조절하는 데 도움이 됩니다.",
    "general1": "2분 동안 천천히 호흡하는 것만으로도 스트레스를 낮추고 집중력을 높일 수 있습니다.",
    "general2": "오늘 감사한 순간 하나를 떠올려 보세요. 작은 긍정적인 생각들이 마음의 건강을 만듭니다.",
    "general3": "오늘 하루를 시작했다는 것 자체가 이미 가장 중요한 습관을 실천하신 거예요."
  },
  "factors": {
    "hydration": "수분 보충",
    "nutrition": "영양",
    "movement": "신체 활동",
    "sleep": "수면"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "식단 옵션을 불러오지 못했습니다",
    "prefsSaved": "음식 취향이 저장되었습니다! 식단을 업데이트 중입니다...",
    "prefsSaveFail": "취향 저장에 실패했습니다",
    "newOptionsFail": "새로운 옵션을 불러오지 못했습니다",
    "invalidZip": "유효한 5자리 우편번호를 입력해 주세요",
    "noVendorsArea": "아직 이 지역에는 이용 가능한 업체가 없습니다. 서비스 지역을 확장 중이에요!",
    "vendorsFetchFail": "업체 정보를 가져오지 못했습니다",
    "selectVendorFirst": "배달 업체를 먼저 선택해 주세요",
    "removedFromCart": "장바구니에서 삭제되었습니다",
    "orderPlaced": "주문이 완료되었습니다! 🎉",
    "enterZipFirst": "배달 섹션에 우편번호를 먼저 입력해 주세요",
    "mealNotAvailable": "이 식단은 현재 고객님의 지역에서 배달이 불가능합니다",
    "mealUnavailable": "근처 업체에서 이 식단을 현재 제공할 수 없습니다",
    "vendorOptionsFail": "업체 옵션을 불러오지 못했습니다",
    "favoriteSaveFail": "즐겨찾기 저장에 실패했습니다",
    "removedFromFavorites": "즐겨찾기에서 삭제되었습니다",
    "favoriteRemoveFail": "즐겨찾기 삭제에 실패했습니다",
    "cartEmpty": "장바구니가 비어 있습니다",
    "noMealOptions": "이용 가능한 식단 옵션이 없습니다",
    "loadingOptions": "식단 옵션을 불러오는 중...",
    "selectPreferences": "선호하는 음식 선택하기",
    "mealBuilder": "식단 구성하기",
    "myFavorites": "나의 즐겨찾기",
    "myFavoriteMeals": "내가 좋아하는 식단",
    "noFavoritesYet": "아직 즐겨찾는 식단이 없어요!",
    "price": "가격",
    "delivery": "배달",
    "deliveryFee": "배달비",
    "distance": "거리",
    "subtotal": "소계",
    "total": "합계",
    "orderNumber": "주문 번호",
    "vendor": "판매 업체",
    "totalAmount": "총 결제 금액",
    "estimatedDelivery": "예상 배달 시간",
    "whyThisMeal": "이 식단의 추천 이유",
    "selectThisMeal": "이 식단 선택하기",
    "swapMeal": "식단 바꾸기",
    "orderThisMeal": "이 식단 주문하기",
    "notAvailableNearYou": "현재 주변에서 이용 불가",
    "tryAdjustingPrefs": "식단 추천을 보려면 음식 취향을 조정해 보세요",
    "myMealPlanSummary": "나의 식단 계획 요약",
    "saveCompletePlan": "전체 계획 저장하기",
    "yourFoodPreferences": "나의 음식 취향",
    "editPreferences": "취향 수정하기",
    "healthyMealDelivery": "건강 식단 배달",
    "enableDelivery": "배달 서비스 활성화",
    "enterZipCode": "이용 가능한 식단을 확인하려면 우편번호를 입력하세요",
    "enterPostcode": "우편번호를 입력해 주세요",
    "postcodePlaceholder": "예: 12345 또는 10001",
    "postcodePartialHint": "더 정확한 지역 결과를 위해 전체 우편번호를 입력해 주세요.",
    "noLocalPartnersFallback": "아직 지역 파트너를 찾지 못했습니다. 대신 문화적으로 친숙한 식재료 제안을 보여드립니다.",
    "noLivePartnersFallback": "현재 이 지역에서 활동 중인 HealthLoop 음식 파트너가 없습니다.",
    "culturalNutritionTitle": "지역 건강식 정보",
    "culturalNutritionSubtitle": "고객님의 지역과 문화에 맞춘 개인별 건강 생활 안내입니다.",
    "viewIngredientGuidance": "가이드 보기",
    "popularWellnessTitle": "내 주변 인기 웰니스 식품",
    "popularWellnessIntro": "고객님의 지역에서 주로 찾는 건강한 식재료와 환경을 소개해 드립니다.",
    "subsectionPopularFoodsTitle": "일상 웰니스 식품",
    "subsectionCulturalIngredientsTitle": "친숙한 식재료 제안",
    "subsectionHealthySwapsTitle": "건강한 대체 아이디어",
    "subsectionLocalEnvironmentTitle": "지역 웰니스 환경",
    "subsectionLocalEnvironmentIntro": "주변에서 건강한 선택지를 찾을 수 있는 장소들입니다.",
    "findLocalTitle": "주변의 건강한 선택지",
    "findLocalSubtitle": "가까운 건강 전문 업체, 상점 및 유용한 식재료를 찾아보세요.",
    "findOptions": "옵션 찾기",
    "searching": "검색 중...",
    "nearbyVendorsFound": "주변에서 {{count}}개의 건강한 옵션을 찾았습니다",
    "orderHintEnabled": "업체별 가격을 확인하려면 아래 식단 카드에서 \"이 식단 주문하기\"를 누르세요.",
    "orderHintDisabled": "식단 카드에서 바로 주문하려면 위에서 배달 서비스 활성화를 켜주세요.",
    "localIngredientTitle": "지역 식재료 가용성",
    "localIngredientIntro": "구하기 쉬운 주요 식재료와 구매처 정보입니다.",
    "lookFor": "찾아볼 항목",
    "noVendorsFallback": "아직 인증된 배달 업체가 없습니다. 위의 식재료 가이드는 근처 마트나 시장에서 활용하실 수 있습니다.",
    "showingMealsFrom": "보여드리는 식단 출처:",
    "sectionSnapshot": "오늘의 영양 요약",
    "sectionSnapshotSubtitle": "오늘의 수분 섭취, 칼로리, 식단 균형을 빠르게 확인하세요.",
    "snapshotHydration": "수분 섭취",
    "snapshotHydrationHint": "오늘 6~8잔을 목표로 해보세요.",
    "snapshotCalories": "칼로리",
    "snapshotCaloriesHint": "기록 기능이 곧 추가됩니다.",
    "snapshotBalance": "식단 균형",
    "mealsLogged": "선택된 식단",
    "snapshotTip": "웰니스 팁",
    "snapshotTipHint": "다음 식사 때 채소를 하나 더 추가해 보세요.",
    "sectionRecommendations": "스마트 추천",
    "sectionRecommendationsSubtitle": "문화적으로 친숙한 식재료 안내와 건강한 대체 아이디어입니다.",
    "sectionGoals": "영양 목표",
    "sectionGoalsSubtitle": "중요하게 생각하는 건강 목표를 추적하세요.",
    "goalWeight": "체중 관리",
    "goalWeightDesc": "지속 가능한 체중 목표에 맞춘 식단입니다.",
    "goalEnergy": "에너지 보충",
    "goalEnergyDesc": "활기찬 하루를 위한 꾸준한 에너지원입니다.",
    "goalImmunity": "면역력 강화",
    "goalImmunityDesc": "항산화 성분이 풍부한 식단 선택입니다.",
    "goalFamily": "가족 영양",
    "goalFamilyDesc": "아이들을 위한 구성과 임산부 옵션이 포함됩니다.",
    "sectionGuidance": "식단 안내",
    "sectionGuidanceSubtitle": "자유롭게 바꿀 수 있는 아침, 점심, 저녁 및 간식 아이디어입니다.",
    "futureNutritionTitle": "향후 영양 지원 계획",
    "futureNutritionBody": "개인 맞춤형 웰니스 영양 정보, 건강 식단 파트너십, 가족 중심 음식 지원 기능이 향후 HealthLoop 업데이트에 추가될 예정입니다.",
    "comingSoon": "준비 중",
    "coverageLocalStores": "지역 건강 상점",
    "coverageLocalFarms": "지역 농장",
    "coverageCertifiedVendors": "인증된 업체",
    "coverageFreshProduce": "신선한 농산물",
    "medWellnessFutureTitle": "복약 및 웰니스 지원",
    "medWellnessFutureDesc": "영양 계획과 복약 상황을 고려한 안내를 결합합니다. 실제 기능은 '지원 및 도움말'에서 제공될 예정입니다.",
    "pharmacyAssistFutureTitle": "약국 지원 서비스",
    "pharmacyAssistFutureDesc": "식단 정보와 함께 근처 약국 찾기 및 복약 알림을 제공합니다. 실제 기능은 '지원 및 도움말'에서 제공될 예정입니다.",
    "savePreferences": "취향 저장하기",
    "quickAccessSavedMeals": "저장된 식단에 빠르게 접근하세요",
    "saveMealsFromBuilder": "식단 구성 탭에서 식단을 저장해 보세요",
    "chooseVendor": "이 식단을 주문할 업체를 선택하세요",
    "yourCart": "장바구니",
    "addMealsToStart": "시작하려면 아래 옵션에서 식단을 추가하세요",
    "orderPlacedDesc": "건강 식단 주문이 성공적으로 접수되었습니다",
    "continueShopping": "계속 쇼핑하기",
    "trackOrder": "주문 추적",
    "healthyStoresTitle": "주변의 건강 상점 및 웰니스 마켓",
    "healthyStoresIntro": "지역 내에서 찾아볼 수 있는 다양한 문화적 특색을 가진 상점들을 소개합니다. (배달 서비스가 아닌 정보 제공용입니다)",
    "healthyStoresGuidanceTitle": "건강한 쇼핑 가이드",
    "healthyStoresDisclaimer": "HealthLoop는 일반적인 웰니스 정보와 건강한 쇼핑 영감을 제공하며, 의료적 진단이나 식이 치료법을 제안하지 않습니다.",
    "healthyStores": {
      "organic": {
        "type": "유기농 식료품점",
        "description": "신선한 무농약 농산물과 가공을 최소화한 필수 식재료를 만나보세요.",
        "tags": [
          "자연식품",
          "신선 농산물"
        ]
      },
      "farmers": {
        "type": "파머스 마켓 (직거래 장터)",
        "description": "생산자가 직접 판매하는 지역 제철 과일, 채소 및 전통 농산물을 구매할 수 있습니다.",
        "tags": [
          "로컬 푸드",
          "제철 음식"
        ]
      },
      "african": {
        "type": "아프리카 신선 농산물점",
        "description": "얌, 플랜테인, 잎채소, 팜넛 등 서부 및 동부 아프리카의 주요 식재료를 취급합니다.",
        "tags": [
          "문화적 특색",
          "신선 농산물"
        ]
      },
      "caribbean": {
        "type": "카리브해 천연 식품 마켓",
        "description": "칼랄루, 카사바, 스카치 보닛, 아키, 빵나무 열매 등 카리브해 지역의 주요 식재료가 있습니다.",
        "tags": [
          "문화적 특색",
          "자연식품"
        ]
      },
      "asian": {
        "type": "아시아 채소 슈퍼마켓",
        "description": "청경채, 무, 연근, 두부, 신선한 허브 등 아시아 전역의 필수 식재료를 만나보세요.",
        "tags": [
          "문화적 특색",
          "신선 농산물"
        ]
      },
      "halal": {
        "type": "할랄 건강 식품 마켓",
        "description": "할랄 인증을 받은 저지방 단백질, 신선 농산물 및 전통 향신료를 판매합니다.",
        "tags": [
          "할랄",
          "문화적 특색"
        ]
      },
      "mediterranean": {
        "type": "지중해 자연 식품 마켓",
        "description": "올리브 오일, 콩류, 신선한 허브, 통곡물 등 지중해 식단의 핵심 재료를 갖추고 있습니다.",
        "tags": [
          "문화적 특색",
          "자연식품"
        ]
      },
      "wellness": {
        "type": "웰니스 전문 식료품점",
        "description": "엄선된 자연 식품, 식물성 옵션 및 성분이 투명한 필수 식재료들을 제공합니다.",
        "tags": [
          "자연식품",
          "식물성 위주"
        ]
      }
    },
    "healthyShoppingTips": [
      "매장 외곽부터 쇼핑하세요 — 신선 농산물, 저지방 단백질, 유제품 대체품은 주로 매장 가장자리에 진열되어 있습니다.",
      "가공이 많이 된 제품보다 원재료 상태의 자연 식품을 선택하세요.",
      "지역 제철 농산물을 선택하세요 — 보통 더 신선하고 저렴하며 영양소가 풍부합니다.",
      "판매자에게 원산지와 재배 방식에 대해 물어보세요 — 많은 판매자가 기쁘게 정보를 공유해 줄 것입니다."
    ]
  },
  "messages": {
    "success": "성공!",
    "error": "오류",
    "saved": "성공적으로 저장되었습니다",
    "updated": "성공적으로 업데이트되었습니다",
    "deleted": "성공적으로 삭제되었습니다",
    "confirmDelete": "정말로 삭제하시겠습니까?",
    "networkError": "네트워크 오류가 발생했습니다. 다시 시도해 주세요.",
    "somethingWrong": "문제가 발생했습니다",
    "failedToLoad": "대시보드를 불러오지 못했습니다",
    "offlineMode": "오프라인 모드 - 제한된 데이터만 표시됩니다",
    "locationDenied": "위치 접근이 거부되었습니다. 브라우저 설정에서 활성화해 주세요.",
    "locationUnavailable": "위치 정보를 사용할 수 없습니다",
    "locationTimeout": "위치 요청 시간이 초과되었습니다. 다시 시도해 주세요.",
    "locationError": "위치 정보에 접근할 수 없습니다",
    "locationGranted": "위치 접근이 허용되었습니다! 주변 옵션을 보여드립니다",
    "locationNotSupported": "브라우저에서 위치 서비스를 지원하지 않습니다",
    "requestingLocation": "위치 접근 권한을 요청 중입니다..."
  },
  "trust": {
    "medicalDisclaimer": "의학적 고지 사항",
    "privacySecure": "데이터는 안전하게 보호됩니다",
    "dataEncrypted": "모든 데이터는 암호화되며 기밀로 유지됩니다",
    "notMedicalAdvice": "의학적 권고 아님",
    "consultProvider": "항상 의료 전문가와 상의하세요",
    "evidenceBased": "근거 기반 가이드",
    "generalEducation": "일반 건강 교육",
    "preventiveGuidance": "예방 차원의 안내",
    "lifestyleSupport": "인식 개선 및 생활 습관 지원용",
    "lastUpdated": "최근 업데이트",
    "expertReviewed": "전문가 검토 완료",
    "aiGenerated": "AI 생성 인사이트",
    "disclaimerShort": "HealthLoop는 건강 교육을 제공하며 전문적인 의학적 권고를 대체하지 않습니다.",
    "disclaimerFull": "HealthLoop는 예방적 웰니스와 조기 인식을 지원합니다. 저희는 건강 교육, 습관 추적, 웰니스 인사이트를 제공합니다. 이는 면허를 가진 의료 서비스의 대체재가 아닙니다. 의학적 권고, 진단 또는 치료에 대해서는 항상 자격을 갖춘 의료 전문가와 상담하십시오.",
    "trustBanner": {
      "title": "HealthLoop는 고객님의 웰니스 여정을 돕습니다",
      "description": "저희는 신뢰할 수 있는 정보를 바탕으로 일반적인 건강 교육과 예방 가이드를 제공합니다. 이는 전문적인 의학적 권고를 대체할 수 없습니다. 의학적 결정 시에는 항상 전문 의료인과 상의해 주세요."
    }
  },
  "health": {
    "preventiveHealth": "예방 건강 추적기",
    "educationHub": "교육 허브",
    "engagementWidget": "참여 위젯",
    "wellnessCheckIn": "웰니스 체크인",
    "todaysMetrics": "오늘의 지표",
    "bloodPressure": "혈압",
    "heartRate": "심박수",
    "weight": "체중",
    "sleep": "수면",
    "waterIntake": "수분 섭취",
    "exercise": "운동",
    "logMetric": "지표 기록",
    "viewHistory": "기록 보기"
  },
  "aiInsights": {
    "title": "AI 건강 인사이트",
    "comingSoon": "인사이트를 수집 중입니다",
    "comingSoonDesc": "매일 한두 번의 체크인을 완료하시면, 고객님만을 위한 부드러운 개인 맞춤형 인사이트를 여기에서 보여드릴게요.",
    "learnMore": "더 알아보기",
    "evidenceSources": {
      "WHO": "WHO 가이드라인 기준",
      "NHS": "NHS 권장사항 준수",
      "CDC": "CDC 가이드라인 기반",
      "RESEARCH": "동료 검토 연구 논문 기준",
      "CLINICAL": "임상 연구 근거"
    }
  },
  "dailyInsight": {
    "title": "오늘의 건강 인사이트",
    "gettingStarted": "시작하기",
    "focus": "집중 항목",
    "quickInsight": "간편 인사이트",
    "simpleExplanation": "쉬운 설명",
    "realLifeImpact": "생활 속 변화",
    "yourActionStep": "실천 단계",
    "basedOnYour": "분석 기준:",
    "personalizedFor": "최근 건강 데이터를 바탕으로 개인화된 정보입니다",
    "getNewInsight": "새 인사이트 받기",
    "newInsightLoaded": "새로운 인사이트가 준비되었습니다! 💡",
    "failedToRefresh": "인사이트 업데이트에 실패했습니다",
    "priority": {
      "high": "여기에 집중해 보세요",
      "medium": "참고할 만한 내용"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "현재 건강 알림이 없습니다",
    "noAlertsDesc": "건강한 습관을 잘 유지하고 계시네요. 계속 노력해 주세요!",
    "whatYouCanDo": "실천해 보세요:",
    "viewMealSuggestions": "개인 맞춤형 식단 제안 보기"
  },
  "engagement": {
    "currentStreak": "현재 연속 기록",
    "bestStreak": "최고 연속 기록",
    "thisWeek": "이번 주",
    "exerciseDays": "운동 일수",
    "hydrationDays": "수분 섭취 일수",
    "healthMetricsLogged": "기록된 건강 지표",
    "weeklyGoalsProgress": "주간 목표 달성도",
    "completed": "완료",
    "days": "일",
    "keepGoing": "계속해 보세요!",
    "personalRecord": "개인 최고 기록!",
    "goalMet": "목표 달성!"
  },
  "reminders": {
    "title": "건강 알림",
    "subtitle": "개인 맞춤형 건강 알림으로 꾸준함을 유지하세요",
    "breakfast": "아침 식사 알림",
    "lunch": "점심 식사 알림",
    "dinner": "저녁 식사 알림",
    "water": "수분 섭취",
    "movement": "활동 시간",
    "sleep": "수면 알림",
    "wellness": "웰니스 체크인",
    "healthLogging": "건강 기록",
    "annualCheckup": "정기 검진",
    "enable": "활성화",
    "disable": "비활성화",
    "customize": "시간 설정",
    "stayConsistent": "스마트 알림으로 꾸준하게",
    "setupFriendly": "건강한 습관을 만들 수 있도록 친절한 알림을 설정해 보세요.",
    "customizeWhen": "각 알림을 얼마나 자주, 언제 받을지 설정할 수 있습니다.",
    "supportive": "걱정 마세요. 방해되지 않도록 따뜻한 격려를 드릴게요! 💚",
    "noPreferences": "알림 설정이 없습니다",
    "noPreferencesDesc": "알림 설정을 불러올 수 없습니다. 처음 방문하셨거나 불러오는 중에 문제가 발생했을 수 있습니다.",
    "retryLoading": "다시 불러오기",
    "saveSettings": "설정 저장",
    "saving": "저장 중..."
  },
  "empty": {
    "startJourney": "웰니스 여정 시작하기",
    "startJourneyDesc": "오늘부터 건강 관리를 시작해 보세요! 현재 기분을 기록하면 개인 맞춤형 인사이트를 받고 시간 변화에 따른 건강 상태를 확인할 수 있습니다.",
    "completeFirstCheckIn": "첫 체크인 완료하기",
    "stayOnTrack": "습관 유지하기",
    "stayOnTrackDesc": "일상을 꾸준히 유지해 보세요 💊 복용 중인 영양제나 약을 추가하면 따뜻한 알림과 도움을 드립니다.",
    "addFirstMedication": "첫 항목 추가하기",
    "learnMedicationSafety": "건강한 관리 방법 알아보기",
    "buildMealLibrary": "나만의 식단 보관함 만들기",
    "buildMealLibraryDesc": "아직 즐겨찾는 식단이 없습니다. 좋아하는 식단을 저장하여 쉽고 빠르게 식단을 계획해 보세요.",
    "exploreMealOptions": "식단 옵션 둘러보기",
    "insightsAwait": "인사이트가 기다리고 있습니다",
    "insightsAwaitDesc": "매일 체크인하고 건강 지표를 기록하여, 개인 맞춤형 건강 분석과 패턴 정보를 확인하세요.",
    "startDailyCheckIn": "데일리 체크인 시작하기",
    "learnAboutInsights": "인사이트에 대해 알아보기",
    "buildingStory": "나만의 웰니스 이야기 만들기",
    "buildingStoryDesc": "아직 기록된 데이터가 없습니다. 매일 체크인을 완료하면 고객님의 건강 트렌드와 패턴이 여기에 표시됩니다.",
    "completeCheckIn": "체크인 완료하기",
    "tipComplete7Days": "팁: 7일 동안 체크인을 완료하면 의미 있는 트렌드와 패턴을 볼 수 있습니다.",
    "startTrackingHabits": "건강한 습관 추적 시작하기",
    "startTrackingHabitsDesc": "아직 추적 중인 습관이 없습니다. 매일의 작은 행동이 지속적인 건강 변화를 만듭니다. 오늘부터 건강한 루틴을 만들어 보세요.",
    "trackFirstHabit": "첫 습관 기록하기",
    "getMoving": "움직여 보세요",
    "getMovingDesc": "아직 활동 기록이 없습니다. 10분만 움직여도 기분과 에너지가 좋아질 수 있습니다.",
    "logActivity": "활동 기록하기",
    "allCaughtUp": "모두 확인했습니다!",
    "allCaughtUpDesc": "새로운 알림이 없습니다. 나중에 다시 확인해 주세요.",
    "noResultsFound": "결과를 찾을 수 없습니다",
    "noResultsFoundDesc": "\"{query}\"에 대한 결과를 찾지 못했습니다. 검색어를 수정하거나 다른 옵션을 찾아보세요."
  },
  "footer": {
    "tagline": "AI 기반의 예방 건강 관리 파트너",
    "builtWith": "여러분의 건강한 여정을 위해 정성껏 만들었습니다",
    "allRightsReserved": "All rights reserved.",
    "about": "소개",
    "privacy": "개인정보 처리방침",
    "terms": "이용약관",
    "contact": "문의하기",
    "helpCenter": "고객센터"
  },
  "modals": {
    "feedback": {
      "title": "의견을 들려주세요",
      "subtitle": "HealthLoop을 개선하는 데 큰 도움이 됩니다",
      "whatWorking": "어떤 점이 만족스러우신가요?",
      "whatImprove": "어떤 점을 개선하면 좋을까요?",
      "placeholder": "자유롭게 의견을 남겨주세요...",
      "thankYou": "소중한 의견 감사합니다!",
      "submitted": "보내주신 의견을 바탕으로 더 나은 HealthLoop을 만들겠습니다."
    },
    "reportProblem": {
      "title": "문제 신고하기",
      "subtitle": "오류 해결과 앱 개선을 도와주세요",
      "describe": "문제 현상 설명",
      "placeholder": "어떤 문제가 발생했나요? 최대한 자세히 적어주세요...",
      "optional": "선택 사항: 재현 순서",
      "stepsPlaceholder": "1. 어디를 클릭했나요?\n2. 그 다음 어떤 현상이 있었나요?",
      "thankYou": "신고해 주셔서 감사합니다!",
      "submitted": "빠르게 확인하여 조치하도록 하겠습니다."
    },
    "mealPreferences": {
      "title": "맞춤 식단 설정",
      "subtitle": "선호하시는 음식 정보를 알려주세요",
      "cuisines": "선호하는 요리 스타일",
      "selectCuisines": "해당되는 항목을 모두 선택해 주세요",
      "dietary": "식단 선호도",
      "selectDietary": "식단 요구 사항을 선택해 주세요",
      "allergies": "알레르기 및 제한 식품",
      "allergiesPlaceholder": "예: 견과류, 갑각류, 글루텐",
      "save": "설정 저장하기",
      "saving": "저장 중..."
    },
    "upgrade": {
      "title": "프리미엄 업그레이드",
      "subtitle": "모든 기능을 자유롭게 이용해 보세요",
      "features": "프리미엄 혜택",
      "getStarted": "시작하기",
      "learnMore": "더 알아보기"
    }
  },
  "login": {
    "title": "예방 중심 건강 인텔리전스 플랫폼",
    "subtitle": "문제가 생기기 전에 미리 기록하고, 배우고, 관리하세요. 예방, 교육, 참여, 그리고 웰니스를 위해 설계되었습니다.",
    "email": "이메일",
    "password": "비밀번호",
    "signIn": "로그인",
    "signingIn": "로그인 중...",
    "forgotPassword": "비밀번호를 잊으셨나요?",
    "noAccount": "계정이 없으신가요?",
    "createAccount": "계정 만들기",
    "biometricLogin": "생체 인증 로그인",
    "biometricHelper": "지문, Face ID 또는 Windows Hello를 사용하세요",
    "authenticating": "인증 중...",
    "vendorPartner": "파트너사 직원이신가요?",
    "vendorLogin": "파트너 전용 로그인",
    "emailRequired": "먼저 이메일을 입력해 주세요",
    "biometricSuccess": "생체 인증으로 로그인되었습니다! 🎉",
    "noPasskeys": "설정된 생체 인증 정보가 없습니다. 먼저 비밀번호로 로그인해 주세요.",
    "biometricCancelled": "생체 인증 로그인이 취소되었습니다",
    "biometricFailed": "생체 인증에 실패했습니다. 비밀번호 로그인을 이용해 주세요."
  },
  "register": {
    "title": "HealthLoop 시작하기",
    "subtitle": "오늘부터 예방 건강 관리를 시작해 보세요",
    "fullName": "이름",
    "email": "이메일",
    "password": "비밀번호",
    "confirmPassword": "비밀번호 확인",
    "createAccount": "계정 만들기",
    "haveAccount": "이미 계정이 있으신가요?",
    "signIn": "로그인",
    "creating": "계정 생성 중...",
    "passwordTooShort": "비밀번호는 8자 이상이어야 합니다",
    "setupBiometric": "생체 인증 설정",
    "setupBiometricDesc": "지문, Face ID 또는 Windows Hello를 사용하면 더 빠르고 안전하게 로그인할 수 있습니다",
    "setupNow": "지금 생체 인증 설정하기",
    "skipForNow": "나중에 하기",
    "settingUp": "설정 중...",
    "benefit1": "비밀번호를 외울 필요가 없습니다",
    "benefit2": "생체 정보 확인으로 보안이 더욱 강화됩니다",
    "benefit3": "가벼운 터치나 시선만으로 바로 로그인하세요",
    "biometricPrivacy": "생체 데이터는 사용자의 기기에만 안전하게 보관됩니다",
    "biometricSuccess": "생체 인증 설정이 완료되었습니다! 🎉",
    "biometricFailed": "생체 인증 설정에 실패했습니다. 나중에 설정 메뉴에서 다시 시도할 수 있습니다.",
    "biometricSetupLater": "나중에 프로필 설정에서 생체 인증을 설정하실 수 있습니다"
  },
  "womensHealthPage": {
    "title": "여성 건강 트래커",
    "subtitle": "생리 주기, 증상, 건강 상태를 기록하세요",
    "cycleOverview": "주기 개요",
    "currentPhase": "현재 단계",
    "nextPeriod": "다음 생리 예정일",
    "logPeriod": "생리 기록하기",
    "logSymptoms": "증상 기록하기",
    "insights": "주기 분석",
    "tips": "단계별 건강 팁",
    "history": "이전 기록",
    "noData": "아직 기록된 데이터가 없습니다",
    "noDataDesc": "주기 기록을 시작하면 맞춤형 분석과 예측 정보를 받아보실 수 있습니다.",
    "startTracking": "기록 시작하기"
  },
  "notifications": {
    "title": "알림",
    "markAllRead": "모두 읽음으로 표시",
    "noNotifications": "새로운 알림이 없습니다",
    "viewAll": "전체 보기"
  },
  "familyHealth": {
    "title": "가족 및 자녀 건강",
    "subtitle": "온 가족을 위한 예방 건강 지원",
    "tabImmunizations": "예방접종",
    "tabEducation": "건강 교육",
    "tabReminders": "알림 설정",
    "tabPlanner": "가족 플래너",
    "immunizations": {
      "title": "예방접종 가이드",
      "subtitle": "권장 백신 정보를 확인하세요",
      "recommendedSchedule": "권장 접종 일정",
      "byAge": "연령대별",
      "infants": "영아 (0-12개월)",
      "toddlers": "유아 (1-3세)",
      "preschool": "미취학 아동 (4-6세)",
      "schoolAge": "학령기 아동 (7-12세)",
      "teens": "청소년 (13-18세)",
      "adults": "성인",
      "learnMore": "더 알아보기",
      "consultDoctor": "개인별 맞춤 접종 상담은 항상 전문의와 상의하세요",
      "upcomingReminders": "다가오는 접종 알림",
      "noReminders": "예정된 접종 알림이 없습니다",
      "addReminder": "접종 알림 추가",
      "reminderFor": "대상자",
      "dueDate": "예정일",
      "notes": "메모",
      "markComplete": "완료 표시"
    },
    "education": {
      "title": "가족 건강 교육",
      "subtitle": "근거 기반의 예방 건강 정보",
      "categories": "카테고리",
      "infant": "영아 돌봄",
      "child": "아동 발달",
      "nutrition": "영양 및 성장",
      "safety": "안전 및 예방",
      "mental": "마음 건강",
      "hygiene": "위생 및 습관",
      "searchPlaceholder": "건강 주제 검색...",
      "popularTopics": "인기 주제",
      "readMore": "더 읽어보기",
      "readTime": "분 소요"
    },
    "reminders": {
      "title": "가족 건강 알림",
      "subtitle": "가족 모두의 예방 관리를 꼼꼼히 챙기세요",
      "createReminder": "알림 만들기",
      "familyMember": "가족 구성원",
      "reminderType": "알림 유형",
      "frequency": "반복 주기",
      "activeReminders": "진행 중인 알림",
      "upcomingThisWeek": "이번 주 예정",
      "noActiveReminders": "활성화된 알림이 없습니다",
      "types": {
        "checkup": "건강 검진",
        "dental": "치과 검진",
        "vision": "시력 검사",
        "vaccine": "예방 접종",
        "medication": "복약 알림",
        "custom": "직접 입력"
      }
    },
    "planner": {
      "title": "가족 건강 플래너",
      "subtitle": "우리 가족의 예방 관리 일정을 조율하세요",
      "addMember": "가족 추가하기",
      "memberName": "이름",
      "relationship": "관계",
      "dateOfBirth": "생년월일",
      "viewCalendar": "캘린더 보기",
      "upcomingCare": "다가오는 예방 관리",
      "nothingScheduled": "예정된 일정이 없습니다",
      "scheduleCheckup": "검진 일정 예약",
      "relationships": {
        "child": "자녀",
        "spouse": "배우자",
        "parent": "부모님",
        "sibling": "형제/자매",
        "other": "기타"
      }
    },
    "content": {
      "infantCare": {
        "title": "영아 예방 관리",
        "intro": "아기의 첫 1년을 위한 필수 예방 건강 수칙",
        "topics": [
          "영유아 검진 일정",
          "주의 깊게 살펴볼 발달 단계",
          "안전한 수면 환경",
          "영양 및 수유 가이드",
          "예방접종 일정"
        ]
      },
      "childDevelopment": {
        "title": "아동 발달 및 성장 단계",
        "intro": "건강한 성장과 발달에 대한 이해",
        "topics": [
          "신체 발달 이정표",
          "사회성 및 정서적 성장",
          "언어 발달 단계",
          "인지적 발달",
          "전문의 상담이 필요한 경우"
        ]
      },
      "nutrition": {
        "title": "영양 및 건강한 성장",
        "intro": "올바른 식습관 형성의 시작",
        "topics": [
          "연령별 맞춤 영양",
          "건강한 간식 아이디어",
          "편식하는 아이 지도법",
          "식품 안전 기초",
          "수분 섭취 가이드"
        ]
      },
      "safety": {
        "title": "안전 및 사고 예방",
        "intro": "우리 가족을 위한 안전한 환경 만들기",
        "topics": [
          "가정 안전 체크리스트",
          "카시트 안전 수칙",
          "물놀이 안전",
          "중독 사고 예방",
          "비상 상황 대비"
        ]
      }
    }
  }
};
